import { getPrimaryLanguageSubtag } from './locale.util';

const SPACED_LOCALES = new Set(['cs', 'sk']);

export function formatPostalCode(code: string, locale?: string): string {
  if (!code) {
    return '';
  }

  const normalized = normalizePostalCode(code);
  const lang = getPrimaryLanguageSubtag(locale);

  if (SPACED_LOCALES.has(lang) && isFiveDigitCode(normalized)) {
    return `${normalized.slice(0, 3)} ${normalized.slice(3)}`;
  }

  return normalized;
}

export function normalizePostalCode(code: string): string {
  return (code ?? '').replace(/\s+/g, '');
}

function isFiveDigitCode(value: string): boolean {
  return /^\d{5}$/.test(value);
}
